import Markdown from "Components/Common/Markdown";
import {Banner} from "Stores/bannerStore";
import React from "react";
import Accordion from "react-bootstrap/Accordion";
import AccordionHeader from "react-bootstrap/AccordionHeader";
interface IAccordionBannerProps {
    year: string
    banners: Banner[]
    index: any
}

interface IAccordionBannerState {
    open: boolean
}


export class AccordionBanner extends React.Component<IAccordionBannerProps, IAccordionBannerState> {

    state = {
        open: false
    };

    renderBannerItem = (banner: Banner) => {
        const date_ddd = (banner.start_date && new Date(banner.start_date).toDateString()) || (banner.enflux_created && new Date(banner.enflux_created).toDateString());
        return (
          <Accordion.Body key={banner.ruuid}>
            <article className="banner-item" style={{ backgroundColor: banner.background_color ? banner.background_color : "white" }}>
              <p className="banner-date-text" style={{ color: banner.color ? banner.color : "" }}>
                {date_ddd}
              </p>
              <p className="banner-text" style={{ color: banner.color ? banner.color : "" }}>
              <Markdown>{banner.banner_text}</Markdown>
              </p>
            </article>
          </Accordion.Body>
        );
      };

    renderContent = () => {
        const { banners } = this.props;
        return banners
          .map(this.renderBannerItem);
      };
    render() {
        return (
            <Accordion defaultActiveKey="0" key={this.props.year}>
                <Accordion.Item eventKey={this.props.index === 0 ? "0" : this.props.index as string} key={this.props.year}>
                    <AccordionHeader> {this.props.year} </AccordionHeader>
                    {this.renderContent()}
                </Accordion.Item>
            </Accordion>
        );
    }


}